import { Navigate, useLocation } from 'react-router-dom';

export const DashboardPage = () => {
    const location = useLocation();
    console.log(600, location);
    <Navigate to="/" />;
};
